import axios from 'axios'
import GoogleMapReact from 'google-map-react'
import React, { useEffect, useState } from 'react'

import settings from 'src/config/settings'

import styles from './GooglePoint.module.scss'

interface IProps {
  Lat: string
  Lng: string
  Label: string
  Address: string
  City: string
  saveData: any
  mapHeight?: number
  className?: string
}

interface ILocation {
  lat: number
  lng: number
}

const apiKey = settings.googleApiKey

const Marker = ({ text }: any) => (
  <>
    <div className={styles.pin}></div>
    <div className={styles.label}>{text}</div>
  </>
)

const GoogleMap = (props: IProps | any) => {
  const [newLocation, setNewLocation] = useState<ILocation | undefined>(undefined)
  const [address, setAddress] = useState<string>('')

  const mapStyle: {
    position: any
    height: string
    minWidth: string
    marginBottom: string
  } = {
    position: 'relative',
    height: props.mapHeight ? `${props.mapHeight}px` : '360px',
    minWidth: '200px',
    marginBottom: '16px',
  }

  const save = (cords: ILocation) => {
    setNewLocation(cords)
    props.saveData(cords.lat.toString(), cords.lng.toString())
  }

  const getCoordsByAddress = () => {
    // URLSearchParams encodes the address, so separators inside it (&, #) cannot
    // inject or truncate query parameters of the geocode request.
    const params = new URLSearchParams({
      address: [props.Address, props.City].filter(Boolean).join(' '),
      key: apiKey,
    })
    const url = `https://maps.googleapis.com/maps/api/geocode/json?${params.toString()}`

    axios
      .get(url, {
        withCredentials: false,
      })
      .then((res) => {
        if (res.data && (res.data as any).results && (res.data as any).results.length) {
          const loc = (res.data as any).results[0].geometry.location
          setNewLocation({
            lat: +loc.lat,
            lng: +loc.lng,
          })
        }
      })

    return
  }

  const setAddressByCoords = (lat: number, lng: number) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=en&result_type=street_address&location_type=ROOFTOP&key=${apiKey}`
    axios.get(url, { withCredentials: false }).then((res) => {
      if (res.data && (res.data as any).results && (res.data as any).results.length) {
        setAddress((res.data as any).results[0].formatted_address)
      }
    })
    return
  }

  useEffect(() => {
    if (props.Lat && props.Lng) {
      setNewLocation({
        lat: +props.Lat,
        lng: +props.Lng,
      })
    } else {
      getCoordsByAddress()
    }
    props.Address && setAddress(props.Address)
  }, [])

  useEffect(() => {
    if (newLocation && newLocation.lat && newLocation.lng)
      setAddressByCoords(newLocation.lat, newLocation.lng)
  }, [newLocation])

  return (
    <div className={props.className}>
      <div style={mapStyle}>
        <GoogleMapReact
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={{ key: apiKey }}
          defaultCenter={newLocation}
          defaultZoom={10}
          options={{ fullscreenControl: false }}
          onClick={(e) => {
            e && save({ lat: e.lat, lng: e.lng })
          }}
        >
          <Marker
            //@ts-ignore
            lat={newLocation?.lat}
            lng={newLocation?.lng}
            text={props.Label || 'Partner Name'}
          />
        </GoogleMapReact>
      </div>
      <div className={styles.info}>
        <div>{address}</div>
      </div>
    </div>
  )
}

export { GoogleMap }
